export class ReadableSizeHelper {
    private binaryPrefixes = ['', 'Ki', 'Mi', 'Gi', 'Ti', 'Pi', 'Ei', 'Zi', 'Yi'];
    private decimalPrefixes = ['', 'k', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y'];
  
    /**
     * Convertit une taille en format lisible (ex: 2048 -> "2 KiB")
     * @param qty        nombre de bytes
     * @param precision  nombre de décimales (défaut: 0)
     * @param type       'binary' (base 1024) ou 'decimal' (base 1000)
     * @param unit       unité finale (par défaut 'o' pour octets)
     */
    public readableSize(
      qty: number,
      precision: number = 0,
      type: 'binary' | 'decimal' = 'binary',
      unit: string = 'o'
    ): string {
      let scale = 1000;
      let prefixes = this.decimalPrefixes;
  
      if (type.toLowerCase() === 'binary') {
        scale = 1024;
        prefixes = this.binaryPrefixes;
      }
  
      let result = qty;
      let numPrefix = 0;
  
      while (result >= scale && numPrefix < prefixes.length - 1) {
        result = result / scale;
        numPrefix++;
      }
  
      // Réduction dynamique de précision inutile
      while (
        precision > 0 &&
        Math.round(result * Math.pow(10, precision)) / Math.pow(10, precision) ===
          Math.round(result * Math.pow(10, precision - 1)) / Math.pow(10, precision - 1)
      ) {
        precision--;
      }
  
      return `${result.toFixed(precision)} ${prefixes[numPrefix]}${unit}`;
    }
  }